// LinkSubstringOembed.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import getCurrentLanguage from '../resource/getCurrentLanguage.js';
import { getIsChinaPartner } from '../resource/partner.js';
import { getIsXUserAgent } from '../resource/getUserAgent.js';

const isChinaPartner = getIsChinaPartner();
const userPageRegExp = /\/(user|u)\/+/g;
export class LinkSubstringOembed extends React.PureComponent {
  componentDidMount() {
    const { url, oembedData, shouldSkipFetch, fetchOembedData } = this.props;
    if (!oembedData && !shouldSkipFetch) {
      this.nextTick = setTimeout(() =>
        fetchOembedData({
          url,
          language: getCurrentLanguage(),
        })
      );
    }
  }
  componentWillUnmount() {
    this.nextTick && clearTimeout(this.nextTick);
  }
  render() {
    const { url, oembedData, key, openUserProfileByWebViewPostMessage } =
      this.props;
    const isInternalLink =
      oembedData?.type === 'link' && !oembedData?.url.match(/^https?:\/\//i);
    const displayTitle = oembedData?.title?.split('\n')[0] || url;
    if (isInternalLink && oembedData?.url) {
      const interalLink = oembedData.url;
      const isUserPage = oembedData.url.match(userPageRegExp);

      if (isUserPage && getIsXUserAgent()) {
        const userId = /user\/([a-z\d]+)$/i.exec(oembedData.url)?.[1];
        return (
          <StyledLink
            key={key}
            onClick={() => {
              openUserProfileByWebViewPostMessage({ userId });
            }}
          >
            @{displayTitle}
          </StyledLink>
        );
      }

      return (
        <StyledLink key={key} as={Link} to={interalLink}>
          {isUserPage ? '@' : ''}
          {displayTitle}
        </StyledLink>
      );
    }

    if (isChinaPartner) {
      return url;
    }

    return (
      <StyledLink
        key={key}
        target="_blank"
        rel="noreferrer noopener"
        href={url}
      >
        {displayTitle}
      </StyledLink>
    );
  }
}

LinkSubstringOembed.propTypes = {
  key: PropTypes.string,
  url: PropTypes.string,
  oembedData: PropTypes.object,
  shouldSkipFetch: PropTypes.bool,
  fetchOembedData: PropTypes.func,
  openUserProfileByWebViewPostMessage: PropTypes.func,
};

LinkSubstringOembed.defaultProps = {
  key: '',
  url: '',
  oembedData: null,
  shouldSkipFetch: false,
  fetchOembedData: () => null,
  openUserProfileByWebViewPostMessage: () => null,
};

const StyledLink = styled.a`
  color: #00d2be;
`;

export default LinkSubstringOembed;
